export enum SubscriptionPlan {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}

export enum SubscriptionAccess {
  FREE = 'FREE',
  PRE_CLINICAL = 'PRE_CLINICAL',
  STEP_SHELF = 'STEP_SHELF',
}

export enum SubscriptionStatus {
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  PAUSED = 'paused',
  FREE = 'free',
}

export interface BillingInfo {
  name?: string;
  email?: string;
  phone?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country?: string;
  };
  tax_ids?: Array<{ value: string }>;
  default_payment_method?: {
    id: string;
  };
}

export interface Subscription {
  id?: string;
  userId?: string;
  stripeCustomerId?: string | null;
  stripeSubscriptionId?: string | null;
  plan?: SubscriptionPlan | null;
  price?: number | null;
  status?: SubscriptionStatus | null;
  trialStart?: string | null;
  trialEnd?: string | null;
  subscriptionStart?: string | null;
  subscriptionEnd?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  accessLevel: SubscriptionAccess;
  grandfathered?: boolean;
  activeDiscount?: boolean;
  discountStart?: string | null;
  discountEnd?: string | null;
  percentOff?: number;
  amountOff?: number;
  couponName?: string | null;
  promotionCode?: string | null;
  cancelAt?: string | null;
  renewsAt?: string | null;
  billsAt?: string | null;
  groupId?: string;
  groupStatus?: 'PENDING' | 'COMPLETE' | 'EXPIRED';
}
